// @format

export function initUserCompanies(): void {
  $(document).on('change', '#edit-user-company-dropdown select', e => {
    window.location.href =
      '/user_companies/' + $('#edit-user-company-dropdown option:selected').val() + '/edit';
  });
}
